import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

export default class extends Controller {
  static targets = ["form"];

  connect() {
    this.submit = debounce(this.submit.bind(this), 500);
  }

  submit() {
    this.formTarget.requestSubmit();
  }

  clear() {
    const fields = this.formTarget.querySelectorAll("input, select, textarea");
    fields.forEach((field) => {
      if (field.type === "checkbox" || field.type === "radio") {
        field.checked = false;
      } else {
        field.value = "";
      }
    });
    this.formTarget.reset();
    this.submit();
  }
}
